import React, { useEffect } from 'react';
import './LoadingScreen.css';
import { useAssetLoader } from '../../../hooks/useAssetLoader';

interface LoadingScreenProps {
  onComplete: () => void;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ onComplete }) => {
  const { isLoaded } = useAssetLoader();

  // Add/remove body class to prevent scrolling
  useEffect(() => {
    document.body.classList.add('loading-screen-active');
    return () => {
      document.body.classList.remove('loading-screen-active');
    };
  }, []);

  useEffect(() => {
    // Assets are loaded, but we'll wait for Hero to be ready
    // The Hero component will call onComplete when it's fully loaded
    if (isLoaded) {
      // Assets are ready, but don't transition yet
      // The Hero component will handle the transition
    }
  }, [isLoaded, onComplete]);

  return (
    <div className='loading-screen'>
      <div className='loading-background'>
        <div className='loading-gradient'></div>
      </div>

      <div className="loading-logo-container show">
        <img
          src='/Cinquity Logo Colored.png'
          alt='Cinquity'
          className='loading-logo fade-in'
        />
        <div className='loading-subtitle'>
          Connecting Healthcare Intelligence
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
